// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BreadCrumbs_wrapper__1LzRb","crumbItem":"BreadCrumbs_crumbItem__1m6Zs","crumbText":"BreadCrumbs_crumbText__3A4dS"};